import { createApp } from 'vue'
import '@/styles/organizer-tokens.css'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
import i18n from './i18n'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || window.location.origin // Adjust this to your backend URL
axios.defaults.withCredentials = true

function syncAxiosAuthHeader() {
  const token = localStorage.getItem('token')
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    axios.defaults.headers.common['X-Access-Token'] = token
  } else {
    delete axios.defaults.headers.common['Authorization']
    delete axios.defaults.headers.common['X-Access-Token']
  }
}

syncAxiosAuthHeader()

// Attach token on every request so refreshes and race conditions cannot drop Authorization
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
    config.headers['X-Access-Token'] = token
  } else {
    delete config.headers.Authorization
    delete config.headers['X-Access-Token']
  }
  return config
})

const app = createApp(App)

app.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err)
  console.error('Error info:', info)
  store.commit('setError', 'An unexpected error occurred. Please try again.')
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const msg = error.response?.data?.message
    const missingToken =
      status === 403 && msg === 'No token provided.'
    if (status === 401 || missingToken) {
      store.dispatch('logout')
      router.push({ name: 'Login' })
    }
    return Promise.reject(error)
  }
)

// Initialize auth state from localStorage (also re-syncs header via setToken when valid)
store.dispatch('initializeAuth').then(() => {
  syncAxiosAuthHeader()
})

app.use(store).use(router).use(i18n).mount('#app')
